import React from 'react';
import cn from 'classnames';
import Icon from 'rawr/style/Icon';
import 'common/Notifications/notifications.scss';
import _ from 'lodash';
import hash from 'rawr/utils/hash';
import LoadingSpinner from 'rawr/controls/LoadingSpinner';

/*
notify("Hello World") // A default notification
notify.error("Oh noes!") or notify("Oh noes!", {type: 'error'}) // With a type of "error"
notify("Self destructing!", {timeout: 5}) // Disappears after 5 seconds
*/

const notifications = [];
const instances = [];

function notify(message, options={}) {
	const config = (_.isObject(message) && message.message) ? message : {message: message};
	_.defaults(config, options, {
		icon: '',
		type: 'notification',
	});
	config.key = config.key || hash(config);
	notifications.push(config);
	render();

	if (config.timeout) {
		setTimeout(() => remove(config.key), config.timeout * 1000);
	}
	return () => remove(config.key);
}

notify.error = function(message, options={}) {
	notify(message, _.assign({type: 'error'}, options));
};

function remove(key) {
	const index = _.findIndex(notifications, {key: key});
	notifications.splice(index, 1);
	render();
}

function render() {
	instances.forEach(i => i.forceUpdate());
}

notify.progress = function progress(loading, success, error) {
	if (loading !== null) {
		var removeProgress = notify(<LoadingSpinner message={loading} key={loading} />);
	}
	return [
		value => {
			if (loading !== null) removeProgress();
			if (success !== null) notify({message: success || 'Complete!', timeout: 2});
			return value;
		},
		reason => {
			if (loading !== null) removeProgress();
			if (error !== null) {
				notify({type: 'error', message: error || reason, timeout: 10});
				throw reason;
			}
		}
	];
};

export {notify};

export default React.createClass({
	componentDidMount() {
		instances.push(this);
	},
	componentWillUnmount() {
		const index = instances.indexOf(this);
		instances.splice(index, 1);
	},
	render() {
		const classes = cn('notification-wrapper', {active : notifications.length > 0});

		return (
			<div className={classes}>
				{notifications.map(function(item, index) {
					const classes = cn('notification-inner cf', {'notification-inner--icon': item.icon}, item.type || 'error');
					return (
						<div className={classes} key={item.key || index}>
							{item.icon && <Icon name={item.icon} classes='custom_icon' size="1em" />}
							<p className="notification-msg before" data-icon={item.icon || 'W'}>{item.message}</p>
							<a className="dismiss" onClick={e => remove(item.key || index)}>
								<Icon name="circle_with_x" size="1em" />
							</a>
						</div>
					);
				}, this)}
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** core/client/rawr/controls/Notifications.jsx
 **/